<template>
	<div style="width: 100%">

		<h1 v-if="node_workflow && node_workflow.description">{{node_workflow.description}}</h1>
		<h1 v-else-if="!minimal">Créer un traitement</h1>

		<p v-if="node_workflow && node_workflow.long_description">{{ node_workflow.long_description }}</p>

		<div v-show="!show_treatment">
			<div v-if="treatment_uid">
				<b-button @click="show_treatment = true;">Revenir au traitement</b-button>
			</div>
			
			<div v-if="!node_workflow || worflow_builder">
				<v-select
					style="width:500px; margin-bottom: 10px!important; display:inline-block"
					v-model="project"
					:options="all_projects ? projects_options : selection_projects_options"
					label="text"
					:reduce="(option) => option.value"
					placeholder="Sélectionner un projet"
					@input="changeProject" />&nbsp;
				<b-button :variant="all_projects ? 'primary' : 'outline-primary'" @click="all_projects = !all_projects">Tous les projets</b-button>
			</div>

			<br />

			<!-- <b-form-select
				v-if="formats_options"
				v-model="format"
				:options="formats_options"
				class="mb-3" /> -->
			<div v-if="documentation">
				<div
					v-for="doc in documentation"
					v-bind:key="doc"
					style="
						display: inline-block;
						margin-right: 5px;
						margin-bottom: 15px;
					">
					<button
						v-if="doc.url"
						data-toggle="tooltip"
						data-placement="bottom"
						:title="doc.description"
						type="button"
						class="btn btn-dark"
						:style="{ 'background-color': doc.Couleur }">
						<a
							v-html="doc.title"
							:href="doc.url"
							style="color: #ffffff"
							target="_blank"></a>
					</button>
					<b-button
						v-if="doc.markdown"
						v-b-modal="doc.slug"
						:style="{ 'background-color': doc.Couleur }"
						>{{ doc.title }}</b-button
					>
					<b-modal
						:hide-footer="true"
						v-if="doc.markdown"
						:title="doc.title"
						size="xl"
						:id="doc.slug"
						><vue-simple-markdown
							:source="doc.markdown"></vue-simple-markdown
					></b-modal>
				</div>
			</div>

			<!-- * tabs pour data (contient la dropzone + traitement) et détails (description projet + description scenario) -->
			<b-tabs v-show="project_obj" content-class="mt-3">
				<b-tab title="Traitement" active>
					<div v-if="!initial_data">
						Données initiales : résultats du précédent traitement
					</div>
					<div v-if="workflow_in_nb > 0">
						Données initiales : <span :style='"opacity:" + (workflow_in ? 1 : 0.5) + ";"'>résultat des éléments liés</span>&nbsp;&nbsp;&nbsp;<b-checkbox switch style="display: inline-block" v-model="workflow_in" 
							:value="false"
							:unchecked-value="true"></b-checkbox> <span :style='"opacity:" + (workflow_in ? 0.5 : 1) + ";"'>autres données</span>
					</div>
					<div v-show="initial_data && (workflow_in_nb == 0 || !workflow_in)">
						<div v-if="initial_method_options && initial_method_options.length > 1">
							<b-form-select
								
								v-model="initial_method"
								:options="
									initial_method_options
								"></b-form-select>
							<br />
							<br />
						</div>

						<div v-if="initial_method === 'google_sheets'" >
							<InitDataGsheets
								ref="start_tabulator">
							</InitDataGsheets>
						</div>
						<div v-if="initial_method === 'airtable'">
							<InitDataAirtable
								ref="start_tabulator">
							</InitDataAirtable>

						</div>
						<div v-if="initial_method == 'fichier'">
							<edit_tabulator
								:selectable="true"
								@data="importFile"
								@filename_changed="name_file = $event"
								ref="start_tabulator"></edit_tabulator>
						</div>
						<div v-if="initial_method == 'base de données'">
							<database
								@update="importFile"
								:change_table="true"
								:name="false"
								:edit="false"
								:start_table="table ? table : null"
								ref="start_tabulator"></database>
						</div>
						<div v-if="initial_method == 'base de données multitables'">
							<DatabaseRequestView
								:minimal="true"
								ref="start_tabulator" />
						</div>
						<div v-show="initial_method == 'fichiers'">
							<vue-dropzone v-if="dz"
								v-on:vdropzone-thumbnail="thumbnail"
								v-on:vdropzone-sending-multiple="sendingEvent"
								v-on:vdropzone-success-multiple="successMultiple"
								v-on:vdropzone-file-added="add"
								v-on:vdropzone-total-upload-progress="progress"
								@vdropzone-error="handleDropzoneError"
								ref="myVueDropzone"
								id="dropzone"
								:options="dropzoneOptions">
							</vue-dropzone>
						</div>
						<div v-if="initial_method == 'fichiers_url'">
							<files-upload 
								:name="false"
								:upload="true"
								ref="start_tabulator" />
						</div>
						<div v-if="initial_method == 'documents'">
							<documents
								:select="true"
								ref="start_tabulator"
								@add_file="set_document_ged"
								:prop_path="(init_data && init_data['documents'] && init_data['documents'].folder) ? init_data['documents'].folder : ''"
								:prop_extension="(init_data && init_data['documents'] && init_data['documents'].extension) ? init_data['documents'].extension : ''"
								:id_prefix="(init_data && init_data['documents'] && init_data['documents'].hasOwnProperty('id_prefix')) ? init_data['documents'].id_prefix : false">
							</documents>
						</div>
						<div v-if="initial_method == 'no'">
							<p>Pas de données initiales</p>
						</div>
						<div v-if="!launch">
							<p></p>
							<span v-for="action in list_actions" :key="action.name">
								<b-button
									:disabled="!project || (formats_options && !format)"
									variant="success"
									v-on:click="
										start(action.tags, action.project, action.type)
									"
									>{{ action.name }}</b-button
								>&nbsp;
							</span>

							<span v-if="nb_files > 0"
								>Nombre de fichiers : {{ nb_files }} - Taille totale :
								{{ size_files }} mo</span
							>
						</div>
						<p></p>
						<div v-if="launch">
							<p>Téléchargement en cours</p>
							<b-progress :value="counter" animated></b-progress>
						</div>
						<p></p>
						<b-table
							v-if="nb_files > 0"
							striped
							hover
							:items="files"
							:fields="fields">
							<template v-slot:cell(del)="data">
								<b-button
									v-on:click="del_file(data.value, data.value.name)"
									><i class="fas fa-trash-alt"></i
								></b-button>
							</template>
						</b-table>
					</div>
					<div v-show="treatment_params.length > 0">
						<h3>Paramètres</h3>
						<treatment_params @configuration="set_configuration" :type_save="user_params_save" :type_save_default="user_params_save_default" :data="tabulator_import_data" :files="files" :url_files="url_files" @button_start="set_button_start" @get_initial_files="get_initial_files" ref="treatment_params"></treatment_params>
					</div>
					<p v-if="cost"><b>Estimation de ChatGPT</b><br />
						{{ (cost).toFixed(4) }}$ par ligne ou document <br />
						{{ tabulator_import_data.length > 0 ? (cost * tabulator_import_data.length).toFixed(4) + "$ au total" : "" }} 
					</p>
					<div v-if="!launch">
						<p></p>
						<span v-if="(initial_method == 'fichiers' && init_data && init_data['fichiers'] && init_data['fichiers'].at_least_one_file && files.length == 0)">
							Il faut au moins un fichier pour démarrer le traitement.
						</span>
						<span v-else>
							<b-button
								:disabled="!project || !button_start || (formats_options && !format) || (initial_method == 'fichiers' && init_data && init_data['fichiers'] && init_data['fichiers'].at_least_one_file && files.length == 0)"
								variant="success"
								v-on:click="start"
								>Démarrer</b-button
							>
						</span>
					</div>
				</b-tab>
				<b-tab title="Informations" v-if="project_obj">
					<!-- * flex project details -->
					<div
						class="d-flex align-items-center justify-content-between"
						v-if="project_obj && project_obj.description.length > 0">
						<div class="description-title font-weight-bold">
							Description du projet
						</div>
						<div style="white-space: pre-line" class="description-body align-text-bottom w-75">
							{{ project_obj.description }}
						</div>
					</div>
					<hr />
					<!-- * flex scenario details -->
					<div
						class="d-flex justify-content-between align-items-center"
						v-if="scenario && ((scenario.description_project && scenario.description_project.length > 0) || scenario.description.length > 0)">
						<div class="description-title font-weight-bold">
							Description du scénario
						</div>
						<div
							style="white-space: pre-line" class="description-body align-text-bottom w-75">
							{{ scenario.description_project || scenario.description }}
						</div>
					</div>
				</b-tab>
			</b-tabs>
		</div>
		<div v-show="show_treatment">
			<b-button @click="show_treatment = false;">Revenir à la création des traitements</b-button>
			<treatment ref="myTreatment" @add_project_workflow="add_project_workflow" :list_projects="list_projects" :workflow="workflow" @set_data_in="set_data_in"></treatment>
		</div>
	</div>
</template>

<script>
	import * as json2csv from "json2csv";
	import vue2Dropzone from "vue2-dropzone";
	import "vue2-dropzone/dist/vue2Dropzone.min.css";
	import FadeLoader from "vue-spinner/src/FadeLoader.vue";

	var clone = require("clone");

	import InitDataAirtable from "../components/Project_v2/init_data_airtable.vue";
	import InitDataGsheets from "../components/Project_v2/init_data_gsheets.vue";
	import DatabaseRequestView from "../views/DatabaseRequestView.vue";
	import treatment_params from "../components/treatment_params.vue"
	import edit_tabulator from "../components/edit_tabulator.vue";
	import file_upload from "../components/file_upload.vue";
	import workers_service from "../services/workers.js";
	import treatments from "../services/treatments.js";
	import projects from "../services/projects.js";
	import documents from "../views/Document.vue";
	import scenario from "../services/scenario";
	import shares from "../services/shares.js"
	import users from "../services/users.js";
	import store from "../store";

	export default {
		name: "create",
		components: {
			vueDropzone: vue2Dropzone,
			FadeLoader: FadeLoader,
			edit_tabulator,
			treatment_params,
			documents,
			DatabaseRequestView,
			InitDataGsheets,
			InitDataAirtable,
			"files-upload": file_upload
		},
		data: function () {
			return {
				first: false,
				dropzoneOptions: {
					url: `${process.env.VUE_APP_SAAS_BACK}` + "/treatments",
					dictDefaultMessage: "Télécharger les fichiers",
					autoProcessQueue: false,
					uploadMultiple: true,
					maxFiles: 10000,
					parallelUploads: 10000,
					previewTemplate: this.template(),
					timeout: 3600000,
					maxFilesize: 10000,
					acceptedFiles: ""
				},
				list_projects: [],
				list_formats: [],
				list_documentation: [],
				list_details: {},
				list_actions: [],

				list_scenarios: [],

				documentation: null,
				projects_options: [
					{ },
				],
				selection_projects_options: [
					{ },
				],
				project: null,
				scenario: null,
				project_obj: null,
				formats_options: null,
				format: null,
				launch: false,
				counter: 0,
				fields: [
					{
						key: "name",
						label: "Nom",
					},
					{
						key: "size",
						label: "Taille",
					},
					{
						key: "del",
						label: "",
					},
				],
				files: [],
				nb_files: 0,
				size_files: 0,
				nb_lines: 0,

				initial_method: "",
				initial_method_options: [
					{ value: "fichiers", text: "Fichiers"},
					{ value: "documents", text: "Documents"},
					{ value: "fichier", text: "Fichier CSV"},
					{ value: "base de données", text: "Base de données"},
					{ value: "base de données multitables", text: "Base de données - multitables"},
					{ value: "no", text: "Pas de fichiers"},
					{ value: "Google Sheets", text: "Google Sheets"},
					{ value: "Airtable", text: "Airtable"},
				],

				table: "",

				dz: true,

				treatment_params: [],
				user_params_save: "",
				user_params_save_default: "",
				init_data: {},

				button_start: true,

				tabulator_import_data: [],
				name_file: "",

				treatment_uid: "",
				show_treatment: false,
				
				refresh: false,

				steps_gpt: [],
				cost: 0,
				all_projects: false,

				launch_line: false,
				test_lines: false,

				test_line_max: 0,
				test_line_nb: 0,
				stop_test: false,
				step_group_line: 1,

				workflow_in: true
			};
		},
		props: {
			default_project: {
			},
			node_workflow: {
				default: () =>  null
			},
			worflow_builder: {
				default: false
			},
			minimal: {},
			initial_data: {
				default: true
			},
			url_files: {
				default: () => [],
			},
			next_treatments: {
				default: () => [],
			},
			workflow: {
				default: false
			},
			workflow_in_nb: {
				default: 0
			}
		},
		watch: {
			treatment_uid()
			{
				if (this.treatment_uid)
				{
					this.$refs.myTreatment.start(this.treatment_uid);
				}
			},
			initial_method(newVal, oldVal) {
				var self = this;
				//console.log(newVal)
				if (newVal == "fichiers")
				{
					this.dz = false;
					if (this.init_data && this.init_data[newVal] && this.init_data[newVal].type)
					{
						this.dropzoneOptions.acceptedFiles = this.init_data[newVal].type;
						this.dropzoneOptions.dictDefaultMessage = "Télécharger les fichiers (format; " + this.dropzoneOptions.acceptedFiles + ")";
					}
					else
					{
						this.dropzoneOptions.acceptedFiles = "";
						this.dropzoneOptions.dictDefaultMessage = "Télécharger les fichiers";
					}
					self.$nextTick(async function () {
						self.dz = false;
						self.$nextTick(async function () {
							self.dz = true;
							self.$nextTick(async function () {
								self.$refs.myVueDropzone.setOption("headers", {
									Authorization: "bearer " + this.$store.state.jwt,
								});
							});
						});
					});
				}
				if (newVal == "base de données")
				{
					if (this.init_data[newVal].params)
					{
						//console.log("this.init_data[newVal].params")
						//console.log(this.init_data[newVal].params)
						self.$nextTick(async function () {
							self.$refs.start_tabulator.load(self.init_data[newVal].params);
						});
					}
					else
					{
						if (this.init_data[newVal].table)
							self.table = this.init_data[newVal].table;
						
						self.$nextTick(async function () {
							self.updateTable()
						});
					}
				}
				if (newVal == "fichier")
				{
					if (this.init_data[newVal].init)
					{
						self.$nextTick(async function () {
							self.$refs.start_tabulator.set_data(this.init_data[newVal].init);
						});
					}
				}
			}
		},
		methods: {
			get_data_in()
			{

			},
			set_data_in()
			{
				this.$emit("set_data_in", this.workflow);
			},
			async save_workflow()
			{
				var data = {
					project: this.project
				};

				return data;
			},
			async load_workflow(data)
			{
			},
			add_project_workflow(workflow, project_uid)
			{
				this.$emit("add_project_workflow", this.workflow, project_uid);
			},
			async importFile() {
				var self = this;

				console.log("import file")

				await this.$nextTick()

				self.tabulator_import_data = this.$refs.start_tabulator.get_data();
			},
            set_button_start(state)
            {
				this.button_start = state
            },
			async set_document_ged(file)
			{
				if (this.$refs.treatment_params)
					this.$refs.treatment_params.set_document_ged(file)
			},
			async get_initial_files(idx)
			{
				//console.log("get_initial_files")
				if (this.$refs.start_tabulator)
					var files = await this.$refs.start_tabulator.get_data_files(false);
				else
				{
					//console.log(this.files)
					var files = this.files;
					for (var i = 0; i < this.files.length; i++)
					{
						files[i] = files[i].file;
					}
				}
				this.$refs.treatment_params.set_initial_files(idx, files);
			},
			template: function () {
				return `<div></div>`;
			},
			thumbnail: function (file, dataUrl) {
				var j, len, ref, thumbnailElement;
				if (file.previewElement) {
					file.previewElement.classList.remove("dz-file-preview");
					ref = file.previewElement.querySelectorAll(
						"[data-dz-thumbnail-bg]"
					);
					for (j = 0, len = ref.length; j < len; j++) {
						thumbnailElement = ref[j];
						thumbnailElement.alt = file.name;
						thumbnailElement.style.backgroundImage =
							'url("' + dataUrl + '")';
					}
					return setTimeout(
						(function (_this) {
							return function () {
								return file.previewElement.classList.add(
									"dz-image-preview"
								);
							};
						})(this),
						1
					);
				}
			},
			getScenarios: async function () {
				try {
					this.list_scenarios = await scenario.getby_production();

					// * converti le tableau de scenarios en objet avec clé = scenario.uid
					this.list_scenarios = this.list_scenarios.reduce(
						(obj, item) => {
							obj[item.uid] = item;
							return obj;
						},
						{}
					);
				} catch (error) {
					console.error(error);
				}
			},
			getProjects: async function () {
				try {
					this.list_projects = await projects.getAll();
				} catch (error) {
					console.error(error);
				}
			},
			async set_configuration(config)
			{
				if (this.steps_gpt.length > 0)
					this.get_cost(config);
			},
            async get_cost(params)
            {
                this.cost = await workers_service.gpt_cost(this.project, this.steps_gpt, params);
                console.log(this.cost);
            },
			get_data_out()
			{
				console.log("create get_data_out")
				var data = this.$refs.myTreatment.get_data_out();

				return data;
			},
			changeProject: async function () {
				var self = this;
				this.format = null;
				this.documentation = null;
				this.launch = false;

				this.project_obj = this.list_projects.find(
					(item) => item.uid === this.project
				);

				if (this.project_obj)
				{
					this.documentation = this.list_documentation[this.project];
					
					if (this.list_details[this.project] && this.list_details[this.project].actions)
						this.list_actions = this.list_details[this.project].actions;
					else 
						this.list_actions = [];

					//console.log(this.project_obj.details.scenario)
					this.scenario = this.list_scenarios[this.project_obj.details.scenario];
					//console.log(this.scenario)
				}
				else
				{
					var project = await projects.get(this.project);
					
					this.documentation = project.documentation;
					if (project.details && project.details.actions)
						this.list_actions = project.details.actions;
					else 
						this.list_actions = [];

					var _scenario = await scenario.getby_id(project.details.scenario)
					if (_scenario.length > 0)
						this.scenario = _scenario[0];
					else
						this.scenario = null;

					//console.log(project)
					//console.log(_scenario)

					self.project_obj = project;
				}

				try 
					{
						if (this.documentation)
							this.documentation = JSON.parse(this.documentation);
					} 
					catch (err) {}

				this.cost = 0;
				this.treatment_params = self.project_obj.details.treatment_params || [];
				this.user_params_save = self.project_obj.details.details ? (self.project_obj.details.details.user_params_save || "") : "";
				this.user_params_save_default = self.project_obj.details.details ? (self.project_obj.details.details.user_params_save_default || "") : "";
				await self.$refs.treatment_params.set(self.treatment_params);
	
				this.steps_gpt = [];
				if (this.scenario)
				{
					for (var i = 0; i < this.scenario.structure.length; i++)
					{
						if (this.scenario.structure[i].action.startsWith("chatgpt"))
							this.steps_gpt.push((i + 1).toString());
					}
				}
				console.log("steps_gpt");
				console.log(this.steps_gpt);

				if (this.steps_gpt.length > 0)
				{
					this.get_cost(this.user_params_save_default || null);
				}

				if (this.workflow)
					this.$emit("set_description_node", this.workflow, self.project_obj.libelle)

				this.init_data = null;
				this.initial_method = "";
				self.$nextTick(async function () {
					self.initial_method_options = [];
					if (self.project_obj.details.init_data)
					{
						if (Object.keys(self.project_obj.details.init_data).length > 0)
						{
							self.init_data = self.project_obj.details.init_data;
							//console.log(self.init_data)
							var keys = Object.keys(self.init_data);
							for (var i = 0; i < keys.length; i++)
							{
								//console.log(self.init_data[keys[i]])
								if (self.init_data[keys[i]].active)
								{
									//console.log("Key: ", keys[i])
									switch(keys[i])
									{
										case "google_sheet":
											self.initial_method_options.push({ value: "Google Sheets", text: "Google Sheets"});
											break;
										case "airtable":
											self.initial_method_options.push({ value: "Airtable", text: "Airtable"});
											break;
										case "fichiers":
											self.initial_method_options.push({ value: "fichiers", text: "Fichiers"});
											break;
										case "documents":
											self.initial_method_options.push({ value: "documents", text: "Documents"});
											break;
										case "fichier":
											self.initial_method_options.push({ value: "fichier", text: "Fichier CSV"});
											break;
										case "fichiers_url":
											self.initial_method_options.push({ value: "fichiers_url", text: "Fichiers - url"});
											break;
										case "base de données":
											self.initial_method_options.push({ value: "base de données", text: "Base de données"});
											break;
										case "base de données multitables":
											self.initial_method_options.push({ value: "base de données multitables", text: "Base de données - multitables"});
											break;
										case "no":
											self.initial_method_options.push({ value: "no", text: "Pas de fichiers"});
											break;
									}
									if (!self.initial_method || self.init_data[keys[i]].default)
										self.initial_method = keys[i];
								}
							}
						}
					}
					if (!self.initial_method)
						self.initial_method = "fichiers";

					//console.log(self.initial_method_options)
				});
			},
			f_stop_test()
			{
				this.stop_test = true;
			},
			async start_line_by_line(_tags, _project, _type) {
				var self = this;

				this.start_project = this.project;
				if (_project) 
					this.start_project = _project;
				this.start_tags = [];
				if (_tags) this.start_tags = _tags;

				this.type = "import";
				if (_type) this.type = _type;

				this.launch_line = true;
				this.test_lines = true;

				await this.$nextTick()

				this.$refs.lines_tabulator.set_data([]);

				var data = await this.$refs.start_tabulator.get_data();

				this.test_line_nb = 0;
				this.test_line_max = data.length;
				this.stop_test = false;

				console.log(data);

				var results_lines = []
				this.step_group_line = parseInt(this.step_group_line);

				for (var i = 0; i < data.length; i += this.step_group_line)
				{
					console.log(i);
					
					var data_line = data.slice(i, i + this.step_group_line)

					data_line = json2csv.parse(data_line, {
						fields: Object.keys(data.length > 0 ? data[0] : []),
						fieldNames: Object.keys(data.length > 0 ? data[0] : []),
					});

					console.log(data_line)

					data_line = new Blob([data_line], {
						type: "text/plain",
					});

					var treatment_data = await treatments.create(
						this.start_project,
						null,
						data_line,
						this.name_file || "data.csv",
						this.start_tags,
						"import",
						null,
						this.$refs.treatment_params.get(),
						null,
						null,
						this.$refs.treatment_params.get_load_name()
					).catch((err) => {
						console.log("error : " + err);
						this.$notify({
							group: "info",
							title: err.response.data.msg,
							type: "error",
						});
					});
					while (
						treatment_data.treatment.resultat != "ok" &&
						treatment_data.treatment.resultat != "ko"
					) {
						await new Promise((resolve) => setTimeout(resolve, 2000));
						treatment_data = await treatments.get(
							treatment_data.treatment.uid
						);
					}
					var all_files = await treatments.getFiles(
						treatment_data.treatment.uid
					);
					if (!all_files || all_files.length == 0) 
						all_files = [];
					
					all_files.sort((a, b) =>
						a.nom_fichier > b.nom_fichier ? 1 : -1
					);

					console.log(all_files)
					
					var export_type = "export";
					var results = []
					var name_file = "";
					for (var j = 0; j < all_files.length; j++) {
						if (
							all_files[j].type == export_type &&
							all_files[j].nom_fichier.endsWith(".csv")						) {
							var csv_data = await treatments.getFile(
								all_files[j].uid,
								all_files[j].nom_fichier,
								false,
								false
							);
							name_file = all_files[j].nom_fichier;
							results = this.$papa.parse(csv_data, {
								header: true,
							});
							results = results.data;
							break;						
						}
					}

					console.log("results");
					console.log(results);

					results_lines = results_lines.concat(results);
					this.$refs.lines_tabulator.set_data(results_lines);

					this.test_line_nb = i + this.step_group_line;

					if (this.stop_test)
					{
						break;
					}
				}

				this.launch_line = false;
			},
			start: async function (_tags, _project, _type) {
				var self = this;

				this.start_project = this.project;
				if (_project) this.start_project = _project;
				this.start_tags = [];
				if (_tags) this.start_tags = _tags;

				this.type = "import";
				if (_type) this.type = _type;

				this.launch = true;
				if (this.workflow_in_nb > 0 && this.workflow_in)
				{
					var data = await this.$parent.get_data_in(this.workflow);

					console.log('start workflow treatment')
					console.log(data);

					var formdata = new FormData();
					var url_files = [];

					for (var i = 0; i < data.length; i++)
					{
						if (data[i].type == "csv")
						{
							formdata.append(data[i].name, data[i].data);
						}
						else if (data[i] instanceof File)
						{
							formdata.append(data[i].name || data[i].upload.filename, data[i]);
						}
						else
						{
							url_files.push({
								url: data[i].url,
								name: data[i].name
							})
						}
					}

					treatments
						.create(
							this.start_project,
							this.format,
							null,
							null,
							this.start_tags,
							"import",
							formdata,
							this.$refs.treatment_params.get(),
							null,
							null,
							this.$refs.treatment_params.get_load_name(),
							url_files
						)
						.then((res) => {
							self.launch = false;
							if (!self.minimal) 
							{
								/*this.$router.push({
									name: "treatment",
									params: { id: res.treatment.uid },
								});*/
								self.treatment_uid = res.treatment.uid;
								self.show_treatment = true;
							}
							else
							{
								this.$emit("launch", res.treatment);
								self.changeProject();
							}
						})
					.catch((err) => {
						console.log("error : " + err);
						this.$notify({
							group: "info",
							text: err.response.data.msg,
							type: "error",
							duration: -1, // * dure infiniment
							closeOnClick: true,
						});
					});

				}
				else if (!this.initial_data)
				{
					var url_files = [];

					for (var i = 0; i < this.url_files.length; i++)
					{
						if (this.url_files[i].type == "export")
							url_files.push(this.url_files[i]);
					}

					treatments
							.create(
								this.start_project,
								this.format,
								null,
								null,
								this.start_tags,
								"import",
								null,
								this.$refs.treatment_params.get(),
								null,
								null,
								this.$refs.treatment_params.get_load_name(),
								url_files
							)
							.then((res) => {
								self.launch = false;
								if (!self.minimal) 
								{
									/*this.$router.push({
										name: "treatment",
										params: { id: res.treatment.uid },
									});*/
									self.treatment_uid = res.treatment.uid;
									self.show_treatment = true;
								}
								else
								{
									this.$emit("launch", res.treatment);
									self.changeProject();
								}
							})
							.catch(() => {
								this.$notify({
									group: "info",
									text: err.response.data.msg,
									type: "error",
									duration: -1, // * dure infiniment
									closeOnClick: true,
								});
								console.error("error");
								this.launch = false;

							});
				}
				else if (this.$refs.myVueDropzone.getQueuedFiles().length > 0) {
					this.$refs.myVueDropzone.processQueue();
				}
				else if (this.initial_method == 'documents')
				{
					var files = await this.$refs.start_tabulator.get_data_files();

					var formdata = new FormData();

					for (var i = 0; i < files.length; i++) {
						formdata.append(files[i].name, files[i]);
					}

					treatments
						.create(
							this.start_project,
							this.format,
							null,
							null,
							this.start_tags,
							"import",
							formdata,
							this.$refs.treatment_params.get(),
							null,
							null,
							this.$refs.treatment_params.get_load_name()
						)
						.then((res) => {
							self.launch = false;
							if (!self.minimal) 
							{
								/*this.$router.push({
									name: "treatment",
									params: { id: res.treatment.uid },
								});*/
								self.treatment_uid = res.treatment.uid;
								self.show_treatment = true;
							}
							else
							{
								this.$emit("launch", res.treatment);
								self.changeProject();
							}
						})
					.catch((err) => {
						console.log("error : " + err);
						this.$notify({
							group: "info",
							text: err.response.data.msg,
							type: "error",
							duration: -1, // * dure infiniment
							closeOnClick: true,
						});
						this.launch = false;

					});
				}
				else {
					if (this.$refs.start_tabulator)
					{
						var csv = await this.$refs.start_tabulator.get_data_blob();

						treatments
						.create(
							this.start_project,
							this.format,
							csv,
							this.name_file || "data.csv",
							this.start_tags,
							"import",
							null,
							this.$refs.treatment_params.get(),
							null,
							null,
							this.$refs.treatment_params.get_load_name()
						)
						.then((res) => {
							self.launch = false;
							if (!self.minimal) 
							{
								/*this.$router.push({
									name: "treatment",
									params: { id: res.treatment.uid },
								});*/
								self.treatment_uid = res.treatment.uid;
								self.show_treatment = true;
							}
							else
							{
								this.$emit("launch", res.treatment);
								self.changeProject();
							}
						})
						.catch((err) => {
							console.error("error " + err);
							this.$notify({
								group: "info",
								text: err.response.data.msg,
								type: "error",
								duration: -1, // * dure infiniment
								closeOnClick: true,
							});
							this.launch = false;

						});						
					}
					else
					{
						treatments
							.create(
								this.start_project,
								this.format,
								null,
								null,
								this.start_tags,
								"import",
								null,
								this.$refs.treatment_params.get(),
								null,
								null,
								this.$refs.treatment_params.get_load_name()
							)
							.then((res) => {
								self.launch = false;
								if (!self.minimal) 
								{
									/*this.$router.push({
										name: "treatment",
										params: { id: res.treatment.uid },
									});*/
									self.treatment_uid = res.treatment.uid;
									self.show_treatment = true;
								}
								else
								{
									this.$emit("launch", res.treatment);
									self.changeProject();
								}
							})
							.catch(() => {
								console.error("error");
								this.$notify({
									group: "info",
									text: err.response.data.msg,
									type: "error",
									duration: -1, // * dure infiniment
									closeOnClick: true,
								});
								this.launch = false;
							});
					}
				}
			},
			sendingEvent(file, xhr, formData) {
				formData.set("project", this.start_project);
				formData.set("type", this.type);
				if (this.format) 
					formData.set("format", this.format);
				formData.set("tags", JSON.stringify(this.start_tags));
				formData.set("params", JSON.stringify(this.$refs.treatment_params.get()));

				var treatment_params_config = this.$refs.treatment_params.get_load_name()
				if (treatment_params_config)
					formData.set("treatment_params_config", treatment_params_config)
			},
			successMultiple(files, response) {
				//this.files = [];
				//this.nb_files = 0;
				//this.size_files = 0;

				console.log(files)

				var self = this;

				if (!this.minimal)
				{
					/*this.$router.push({
						name: "treatment",
						params: { id: res.treatment.uid },
					});*/
					self.treatment_uid = response.treatment.uid;
					self.show_treatment = true;
					this.launch = false;
				}
				else
				{
					this.$emit("launch", response.treatment);
					this.changeProject();
				}

				this.$nextTick(() => {
					for (var i = 0; i < files.length; i++)
					{
						files[i].status = "queued";
					}
				});
			},
			add(file) {
				this.files.push({
					name: file.name,
					size: (file.size / 1000000).toFixed(3) + " mo",
					nb_size: file.size / 1000000,
					del: file.upload.uuid,
					file: file
				});
				this.nb_files++;
				this.size_files = (
					parseFloat(this.size_files) +
					parseFloat(file.size / 1000000)
				).toFixed(3);
			},
			del_file(uuid) {
				var dropzone_files = this.$refs.myVueDropzone.getQueuedFiles();
				var size = 0;

				for (var i = 0; i < dropzone_files.length; i++) {
					if (dropzone_files[i]["upload"]["uuid"] == uuid) {
						size = dropzone_files[i]["size"];
						this.$refs.myVueDropzone.removeFile(dropzone_files[i]);
					}
				}
				for (var i = 0; i < this.files.length; i++) {
					if (this.files[i].del == uuid) {
						this.nb_files--;
						this.size_files = (
							parseFloat(this.size_files) -
							parseFloat(size / 1000000)
						).toFixed(3);
						this.files.splice(i, 1);
					}
				}
			},
			progress(totaluploadprogress, totalBytes, totalBytesSent) {
				this.counter = totaluploadprogress;
			},
			async updateTable() {
				var self = this;
				self.$refs.start_tabulator.init(self.table);
			},
			handleDropzoneError(file, message, xhr) {
				this.$notify({
					group: "info",
					text: message.msg,
					type: "error",
					duration: -1, // * dure infiniment
					closeOnClick: true,
				});
				this.launch = false;

				// Tu peux aussi afficher l'erreur dans l'UI :
			},
		},
		mounted: async function () {
			if (store.state.user.rules && !store.state.user.rules.projects) {
				this.$router.push({ name: "profile" });
			}

			if (store.state.user.rules && store.state.user.rules.hide_create_projects) {
				this.$router.push({ name: "profile" });
			}

			var self = this;
			var user = store.state.user;
			this.resolve = null;

			var response = await users.getSelf(true);
			this.client = response.client;

			this.$refs.myVueDropzone.setOption("headers", {
				Authorization: "bearer " + this.$store.state.jwt,
			});
			await this.getProjects();
			await this.getScenarios();
			for (var i = 0; i < this.list_projects.length; i++) {
				// console.log(clone(this.list_projects[i]));
				if (store.state.user.rules && store.state.user.rules.projects_hide && store.state.user.rules.projects_hide.includes(this.list_projects[i].uid))
					continue;
				if (this.list_projects[i].details && this.list_projects[i].details.hasOwnProperty("inDropdownTraitements") && this.list_projects[i].details.inDropdownTraitements === false)
					continue;

				this.list_formats[this.list_projects[i]["uid"]] = null;
				this.list_documentation[this.list_projects[i]["uid"]] = this.list_projects[i]["documentation"];
				this.list_details[this.list_projects[i]["uid"]] = this.list_projects[i]["details"];
				this.projects_options.push({
					value: this.list_projects[i]["uid"],
					text: this.list_projects[i]["libelle"],
				});
				if (this.next_treatments && this.next_treatments.length > 0)
				{
					if (this.next_treatments.includes(this.list_projects[i]["uid"]))
					{
						this.selection_projects_options.push({
							value: this.list_projects[i]["uid"],
							text: this.list_projects[i]["libelle"],
						});
					}
				}
				else if (!(this.list_projects[i]["details"] && this.list_projects[i]["details"]["details"] && this.list_projects[i]["details"]["details"].sub_treatment))
				{
					this.selection_projects_options.push({
						value: this.list_projects[i]["uid"],
						text: this.list_projects[i]["libelle"],
					});
				}
				if (this.list_projects[i]["formats"]) 
				{
					this.list_formats[this.list_projects[i]["uid"]] = [{ value: null, text: "Sélectionner un format" }];
					for (var j = 0; j < this.list_projects[i]["formats"].length; j++) 
					{
						if (this.list_projects[i]["formats"][j]["usage"] =="Import") 
						{
							this.list_formats[this.list_projects[i]["uid"]].push({value: this.list_projects[i]["formats"][j]["uid"], text: this.list_projects[i]["formats"][j]["libelle"],});
						}
					}
					if (this.list_formats[this.list_projects[i]["uid"]].length <= 1) {
						this.list_formats[this.list_projects[i]["uid"]] = null;
					}
				}
			}

			if (this.default_project)
			{
				this.project = this.default_project;
				this.changeProject();
			}

			/*if (this.client && this.client.details && this.client.details.share_get)
			{
				var list_get = await shares.list("get", "project");
				var list_get_id = [];

				var shared_project = {
					label: "Projets partagés",
					options: []
				};

				for (var i = 0; i < list_get.length; i++)
				{
					if (!list_get_id.includes(list_get[i].element_uid))
					{
						list_get_id.push(list_get[i].element_uid);
						shared_project.options.push({
							value: list_get[i].element_uid,
							text: list_get[i].details.name,
						})
					}
				}

				shared_project.options.sort((a, b) =>
					a.text.toLowerCase() > b.text.toLowerCase() ? 1 : -1
				);

				console.log(shared_project)
				if (shared_project.options.length > 1)
					this.projects_options.push(shared_project);
			}*/
		},
	};
</script>

<style>
	.description-title {
		font-size: x-large;
		width: 20%;
	}

	.description-body {
		font-size: large;
	}

	.center_spinner {
		width: 0%;
		margin: 0 auto;
		margin-top: 30px;
	}

	#dropzone .dz-message {
		margin: 0.5em 0;
	}

	#dropzone .dz-preview {
		width: 160px;
		display: inline-block;
	}
	#dropzone .dz-preview .dz-image > div {
		width: inherit;
		height: inherit;
		border-radius: 50%;
		background-size: contain;
	}
	#dropzone .dz-preview .dz-image > img {
		width: 100%;
	}

	#dropzone .dz-preview .dz-details {
		color: rgb(0, 0, 0);
		transition: opacity 0.2s linear;
		text-align: center;
	}
	#dropzone .dz-success-mark,
	.dz-error-mark,
	.dz-remove {
		display: none;
	}

	.dropzone.dz-started .dz-message {
		display: block;
	}
</style>
